import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCameraStore = defineStore('camera', () => {
  const videoElement = ref(null);
  const mediaStream = ref(null);
  const currentMediaRecorder = ref(null);
  const isCameraOpen = ref(false);
  const isMediaRecording = ref(false);
  const cameras = ref([]);
  const cameraIndex = ref(0);
  const cameraId = ref("");
  const constraints = ref(null);
  const flashModes = ref([]);
  const flashMode = ref("");
  const currentFlashModeIndex = ref(0);
  const torchSupported = ref(false);
  const torchActive = ref(false);
  const front = ref(false);
  const currMediaStream = ref(null);

  function setVideoElement(element) {
    videoElement.value = element;
  }

  function resetState() {
    videoElement.value = null;
    mediaStream.value = null;
    currentMediaRecorder.value = null;
    isCameraOpen.value = false;
    isMediaRecording.value = false;
  }

  return {
    videoElement,
    mediaStream,
    currentMediaRecorder,
    isCameraOpen,
    isMediaRecording,
    cameras,
    cameraIndex,
    cameraId,
    constraints,
    flashModes,
    flashMode,
    currentFlashModeIndex,
    torchSupported,
    torchActive,
    front,
    currMediaStream,
    setVideoElement,
    resetState
  };
});
